import { sendDelete, sendGet, sendPost, sendPut } from "./axios";

export const getListStore = (params) => sendGet("/stores", params);
export const createStore = (params) => sendPost("/stores", params);

export const updateStore = (id, params) =>
  sendPut(`/stores/${id}`, params);

export const deleteStore = (id) => sendDelete(`/stores/${id}`);
